(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gueray-home-v5-brand-manifesto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initManifestoTabs = root => {
      if (!root || root.dataset.gv5ManifestoInitialized === 'true') return;
      root.dataset.gv5ManifestoInitialized = 'true';

      const tabs = Array.from(root.querySelectorAll('.gv5-manifesto__tab[data-value-index]'));
      const images = Array.from(root.querySelectorAll('.gv5-manifesto__image[data-value-index]'));
      if (!tabs.length || !images.length) return;

      // Keep inactive panels out of the initial render/load path, then restore the
      // overlapping panels shortly before this section is viewed so opacity fades
      // remain intact when shoppers switch values.
      images.forEach(image => image.removeAttribute('hidden'));

      const track = root.querySelector('[data-gy-mobile-track]');
      const segments = Array.from(root.querySelectorAll('[data-gy-mobile-segment]'));
      const prevButton = root.querySelector('[data-gy-mobile-prev]');
      const nextButton = root.querySelector('[data-gy-mobile-next]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let activeIndex = tabs.findIndex(tab => tab.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      const normalizeIndex = index => {
        const parsed = Number(index);
        if (!Number.isFinite(parsed)) return activeIndex;
        return Math.max(0, Math.min(tabs.length - 1, parsed));
      };

      const activate = (index, options = {}) => {
        const normalizedIndex = normalizeIndex(index);
        activeIndex = normalizedIndex;

        tabs.forEach(tab => {
          const active = tab.dataset.valueIndex === String(normalizedIndex);
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = 0;
        });

        images.forEach(image => {
          const active = image.dataset.valueIndex === String(normalizedIndex);
          image.classList.toggle('is-active', active);
          image.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        segments.forEach((segment, segmentIndex) => {
          const active = segmentIndex === normalizedIndex;
          segment.classList.toggle('is-active', active);
          if (active) {
            segment.setAttribute('aria-current', 'true');
          } else {
            segment.removeAttribute('aria-current');
          }
        });

        if (prevButton) prevButton.disabled = normalizedIndex === 0;
        if (nextButton) nextButton.disabled = normalizedIndex === tabs.length - 1;

        if (options.scroll && mobileQuery.matches && tabs[normalizedIndex]) {
          tabs[normalizedIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      tabs.forEach(tab => {
        const index = tab.dataset.valueIndex;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) activate(index);
        });
        tab.addEventListener('keydown', event => {
          const current = tabs.indexOf(tab);
          let next = null;
          if (event.key === 'ArrowRight') next = tabs[current + 1] || tabs[0];
          if (event.key === 'ArrowLeft') next = tabs[current - 1] || tabs[tabs.length - 1];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            activate(next.dataset.valueIndex);
            next.focus();
          }
        });
      });

      let trackWidth = 0;
      let tabCenters = [];

      const measureTrack = () => {
        if (!track || !mobileQuery.matches) return;
        const trackRect = track.getBoundingClientRect();
        trackWidth = track.clientWidth;
        tabCenters = tabs.map(tab => {
          const tabRect = tab.getBoundingClientRect();
          return track.scrollLeft + tabRect.left - trackRect.left + (tabRect.width / 2);
        });
      };

      const syncFromTrack = () => {
        if (!track || !mobileQuery.matches) return;
        if (!tabCenters.length) measureTrack();

        const trackCenter = track.scrollLeft + (trackWidth / 2);
        let closestIndex = activeIndex;
        let closestDistance = Number.POSITIVE_INFINITY;

        tabCenters.forEach((tabCenter, index) => {
          const distance = Math.abs(tabCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        activate(closestIndex);
      };

      let scrollFrame = 0;
      let resizeFrame = 0;
      let trackResizeObserver = null;

      const scheduleTrackMeasure = () => {
        if (!mobileQuery.matches || resizeFrame) return;
        resizeFrame = window.requestAnimationFrame(() => {
          resizeFrame = 0;
          measureTrack();
        });
      };

      const syncTrackMeasurementMode = () => {
        if (!track) return;

        if (!mobileQuery.matches) {
          trackResizeObserver?.disconnect();
          trackResizeObserver = null;
          trackWidth = 0;
          tabCenters = [];
          return;
        }

        if ('ResizeObserver' in window && !trackResizeObserver) {
          trackResizeObserver = new ResizeObserver(scheduleTrackMeasure);
          trackResizeObserver.observe(track);
        }
        scheduleTrackMeasure();
      };

      if (track) {
        track.addEventListener('scroll', () => {
          if (!mobileQuery.matches) return;
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(syncFromTrack);
        }, { passive: true });

        window.addEventListener('resize', scheduleTrackMeasure, { passive: true });
        if (mobileQuery.addEventListener) {
          mobileQuery.addEventListener('change', syncTrackMeasurementMode);
        } else {
          mobileQuery.addListener(syncTrackMeasurementMode);
        }
        syncTrackMeasurementMode();
      }

      segments.forEach((segment, index) => {
        segment.addEventListener('click', () => activate(index, { scroll: true }));
      });

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          activate(Math.max(activeIndex - 1, 0), { scroll: true });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          activate(Math.min(activeIndex + 1, tabs.length - 1), { scroll: true });
        });
      }

      root.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!target) return;

        const segment = target.closest('[data-gy-mobile-segment]');
        const prev = target.closest('[data-gy-mobile-prev]');
        const next = target.closest('[data-gy-mobile-next]');

        if (segment && root.contains(segment)) {
          const segmentIndex = segments.indexOf(segment);
          if (segmentIndex >= 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            activate(segmentIndex, { scroll: true });
          }
          return;
        }

        if (prev && root.contains(prev)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          activate(Math.max(activeIndex - 1, 0), { scroll: true });
          return;
        }

        if (next && root.contains(next)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          activate(Math.min(activeIndex + 1, tabs.length - 1), { scroll: true });
        }
      }, true);

      root.addEventListener('focusin', event => {
        const tab = event.target.closest('.gv5-manifesto__tab[data-value-index]');
        if (tab && root.contains(tab)) activate(tab.dataset.valueIndex);
      });

      activate(tabs.find(tab => tab.classList.contains('is-active'))?.dataset.valueIndex || tabs[0].dataset.valueIndex || 0);
    };

    const observedManifestoSections = new WeakSet();
    const initAllManifestoTabs = root => {
      (root || document).querySelectorAll('[data-gv5-manifesto-section]').forEach(section => {
        if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          initManifestoTabs(section);
          return;
        }
        if (observedManifestoSections.has(section)) return;
        observedManifestoSections.add(section);
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          initManifestoTabs(section);
        }, { rootMargin: '320px 0px' });
        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllManifestoTabs(document), { once: true });
    } else {
      initAllManifestoTabs(document);
    }
    document.addEventListener('shopify:section:load', event => initAllManifestoTabs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gueray-home-v5-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-gv5-hero-slider]';

    const initSlider = hero => {
      if (!hero || hero.dataset.gySliderReady === 'true') return;

      const slides = Array.from(hero.querySelectorAll('[data-gv5-hero-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-gv5-hero-dot]'));
      const previous = hero.querySelector('[data-gv5-hero-prev]');
      const next = hero.querySelector('[data-gv5-hero-next]');
      const status = hero.querySelector('[data-gv5-hero-status]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoRotate = hero.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
      const interval = Math.max(Number(hero.dataset.interval) || 6000, 3000);
      let activeIndex = Math.max(slides.findIndex(slide => slide.classList.contains('is-active')), 0);
      let timer = null;
      let touchStartX = 0;
      let touchStartY = 0;

      if (slides.length < 2) {
        hero.dataset.gySliderReady = 'true';
        return;
      }

      const normalize = index => (index + slides.length) % slides.length;

      const showSlide = (index, announce = true) => {
        activeIndex = normalize(index);
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.setAttribute('tabindex', active ? '0' : '-1');
        });
        if (status && announce) status.textContent = `Slide ${activeIndex + 1} of ${slides.length}`;
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (autoRotate && !document.hidden) {
          timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
        }
      };

      const move = direction => {
        showSlide(activeIndex + direction);
        start();
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
        showSlide(dotIndex);
        start();
      }));

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', event => {
        if (!hero.contains(event.relatedTarget)) start();
      });

      hero.addEventListener('touchstart', event => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        stop();
      }, { passive: true });

      hero.addEventListener('touchend', event => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) > 52 && Math.abs(deltaX) > Math.abs(deltaY)) {
          showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
        }
        start();
      }, { passive: true });

      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      showSlide(activeIndex, false);
      start();
      hero.dataset.gySliderReady = 'true';
    };

    const init = root => {
      if (root.matches?.(selector)) initSlider(root);
      root.querySelectorAll?.(selector).forEach(initSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest?.('[data-gv5-hero-slide]');
      const hero = slide?.closest(selector);
      if (!slide || !hero) return;
      const slides = Array.from(hero.querySelectorAll('[data-gv5-hero-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-gv5-hero-dot]'));
      const selectedIndex = slides.indexOf(slide);
      slides.forEach((item, index) => {
        const active = index === selectedIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        const active = index === selectedIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
